import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { formatUnits } from "viem";
import { useBalance } from "wagmi";
import { isNativeToken } from "../../utils/index.js";
/**
 * Hook to watch for incoming transfers to an address by monitoring balance changes.
 * When a transfer is detected (balance increases), it captures the amount and notifies.
 */
export function useWatchTransfer(t0) {
  const $ = _c(23);
  const {
    address,
    chainId,
    tokenAddress,
    tokenDecimals,
    enabled: t1,
    onTransferDetected
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const [transferResult, setTransferResult] = useState(null);
  const [isWatching, setIsWatching] = useState(false);
  const initialBalanceRef = useRef(null);
  const transferDetectedRef = useRef(false);
  const isNative = isNativeToken(tokenAddress);
  const t2 = isNative ? undefined : tokenAddress;
  const t3 = enabled && !!address;
  let t4;
  if ($[0] !== t3) {
    t4 = {
      enabled: t3,
      refetchInterval: 3000
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== address || $[3] !== chainId || $[4] !== t2 || $[5] !== t4) {
    t5 = {
      address,
      chainId,
      token: t2,
      query: t4
    };
    $[2] = address;
    $[3] = chainId;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    data: balanceData,
    refetch: refetchBalance
  } = useBalance(t5);
  let t6;
  let t7;
  if ($[7] !== balanceData || $[8] !== enabled) {
    t6 = () => {
      if (balanceData && initialBalanceRef.current === null && enabled) {
        initialBalanceRef.current = balanceData.value;
        setIsWatching(true);
      }
    };
    t7 = [balanceData, enabled];
    $[7] = balanceData;
    $[8] = enabled;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[11] !== balanceData || $[12] !== enabled || $[13] !== onTransferDetected || $[14] !== tokenDecimals) {
    t8 = () => {
      if (!enabled || transferDetectedRef.current || initialBalanceRef.current === null || !balanceData) {
        return;
      }
      const currentBalance = balanceData.value;
      const initialBalance = initialBalanceRef.current;
      if (currentBalance > initialBalance) {
        const transferAmount = currentBalance - initialBalance;
        const formattedAmount = formatUnits(transferAmount, tokenDecimals);
        const result = {
          amount: transferAmount.toString(),
          formattedAmount,
          timestamp: Date.now()
        };
        transferDetectedRef.current = true;
        setTransferResult(result);
        setIsWatching(false);
        onTransferDetected?.(result);
      }
    };
    t9 = [balanceData, enabled, tokenDecimals, onTransferDetected];
    $[11] = balanceData;
    $[12] = enabled;
    $[13] = onTransferDetected;
    $[14] = tokenDecimals;
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  useEffect(t8, t9);
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      transferDetectedRef.current = false;
      initialBalanceRef.current = null;
      setTransferResult(null);
      setIsWatching(false);
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const reset = t10;
  let t11;
  const t12 = transferResult !== null;
  let t13;
  if ($[18] !== isWatching || $[19] !== refetchBalance || $[20] !== t12 || $[21] !== transferResult) {
    t13 = {
      isWatching,
      transferResult,
      hasTransfer: t12,
      reset,
      refetchBalance
    };
    $[18] = isWatching;
    $[19] = refetchBalance;
    $[20] = t12;
    $[21] = transferResult;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  t11 = t13;
  return t11;
}